import { Box, Typography } from "@mui/material";
import { TraderType } from "../../types/Trader/Trader";
import { Affiliate } from "../../types/affiliate/affiliate";
import { useAuth } from "../../providers/AuthenticationProvider";
import { useTranslation } from "react-i18next";

const AffiliateInfo = ({ affiliate }: { affiliate: Affiliate }) => {
	const { user } = useAuth();
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				gap: "4px",
				flexDirection: "column",
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: "16px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: { xs: "flex-start", sm: "center" },
						alignItems: { xs: "flex-start", sm: "center" },
						width: "fit-content",
						flexDirection: { xs: "column", sm: "row" },
					}}
				>
					<Typography
						variant="body1"
						fontSize="32px"
						sx={{ marginRight: "5px" }}
					>
						{t("general.welcome")}{" "}
					</Typography>
					<Typography
						variant="body1"
						fontSize="32px"
						fontWeight="bold"
						sx={{ marginLeft: { xs: "12px", sm: "unset" } }}
					>
						{user?.email}
					</Typography>
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					justifyContent: { xs: "flex-start", sm: "center" },
					alignItems: { xs: "flex-start", sm: "center" },
					width: "fit-content",
					flexDirection: { xs: "column", sm: "row" },
				}}
			>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						width: "fit-content",
					}}
				>
					<Typography
						variant="body1"
						fontSize="12px"
						sx={{ marginRight: "5px" }}
					>
						referral:{" "}
					</Typography>
					<a
						href={"https://xseetrading.com?code=" + affiliate.code}
						style={{ color: "#147A7A" }}
					>
						<Typography
							variant="body1"
							fontSize="12px"
							fontWeight="bold"
						>
							https://xseetrading.com?code={affiliate.code}
						</Typography>
					</a>
				</Box>
			</Box>
		</Box>
	);
};

export default AffiliateInfo;
